import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

/** Absolute paths for the current W2 flow's child routes (frozen route map C-1). */
export interface W2Paths {
  root: string; // /e/<token>
  register: string; // /e/<token>/register
  login: string; // /e/<token>/login
  forgot: string; // /e/<token>/forgot
  reset: string; // /e/<token>/reset
  phq: string; // /e/<token>/phq
  done: string; // /e/<token>/done
}

/** Pure builder — usable outside React (tests, the redirect shim). */
export function w2Paths(employerToken: string): W2Paths {
  const root = `/e/${encodeURIComponent(employerToken)}`;
  return {
    root,
    register: `${root}/register`,
    login: `${root}/login`,
    forgot: `${root}/forgot`,
    reset: `${root}/reset`,
    phq: `${root}/phq`,
    done: `${root}/done`,
  };
}

/** Route-param-bound builders. Valid anywhere under `/e/:employerToken/*`. */
export function useW2Paths(): W2Paths {
  const { employerToken = '' } = useParams<'employerToken'>();
  return useMemo(() => w2Paths(employerToken), [employerToken]);
}
